module.exports = __webpack_public_path__ + "static/media/214-malawi.9174a6da.svg";